"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Dropdown = require("../../components/Dropdown/Dropdown.styles");
var _Listbox = require("../../components/Listbox/Listbox.styles");
var ComboboxMixin = function ComboboxMixin(props) {
  var fluidDropdown = props.fluidDropdown;
  if (fluidDropdown) {
    return (0, _styledToken.default)({
      dropdownWidth: 'Combox.Dropdown.width',
      listboxBorder: 'Combobox.Listbox.border'
    }, function (_ref) {
      var _ref$dropdownWidth = _ref.dropdownWidth,
        dropdownWidth = _ref$dropdownWidth === void 0 ? '100%' : _ref$dropdownWidth,
        _ref$listboxBorder = _ref.listboxBorder,
        listboxBorder = _ref$listboxBorder === void 0 ? 'none' : _ref$listboxBorder;
      return (0, _styledComponents.css)(["position:relative;", "{width:", ";}", "{border:", ";}"], _Dropdown.StyledDropdown, dropdownWidth, _Listbox.StyledListbox, listboxBorder);
    })(props);
  }
  return '';
};
exports.ComboboxMixin = ComboboxMixin;